
import { Link } from 'react-router'

import evenLinkLogo from 'assets/images/evenlink-logo.png';
import { Administrator } from 'shared/topchef.types'

export interface BackofficeMenuProps {
  loggedInAdmin: Administrator,
}


const BackofficeMenu = ({loggedInAdmin}: BackofficeMenuProps) => {

  return (
    <>
      <div id="sidebar" className="d-flex flex-column flex-shrink-0 p-3 pt-5 bg-light vh-100 justify-content-between" style={{width: 200}}>
      <div className="row g-3">
        <div id="profil_sidebar">
          <div id="app_title" className="d-flex align-items-center">    
              <img src={evenLinkLogo} alt="EventLink logo" className="" style={{width: 150}} />
          </div>
          <div id="host_infos" className="row gap-1 mt-3">
              <span className="listing-name fw-bold">{loggedInAdmin.name}</span>
          </div>
        </div>
          <div id="dashboard_sidebar">
            <span className="text-left">Tableau de bord</span>
            <ul className="nav nav-pills flex-column mb-auto">
                <li className="nav-item"><Link to={'dashboard'} className="nav-link bo-dashboard-link">Dashboard</Link></li>
                <li className="nav-item"> <Link to={'leads/all'} className="nav-link bo-all-briefs">Tous les briefs</Link></li>
                <li className="nav-item"> <Link to={'leads/to-validate'} className="nav-link bo-leads-to-validate-link">Briefs à valider</Link></li>
                <li className="nav-item"> <Link to={'leads/bills-to-validate'} className="nav-link bo-bills-to-validate-link">Factures à valider</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </>
    
  );

}

export default BackofficeMenu;
